import { ADD_EXPERIMENT, CLEAR_EXPERIMENT } from './const';

/**
 * Adds experiment variants
 * @param {object} experimentResults - results from experiment
 * @returns {object} an action with type ADD_EXPERIMENT and the given payload
 */
export const addExperimentVariants = experimentResults => ({
  type: ADD_EXPERIMENT,
  ...experimentResults
});

/**
 * Adds experiment variants
 * @returns {object} an action with type CLEAR_EXPERIMENT
 */
export const clearExperiment = () => ({
  type: CLEAR_EXPERIMENT
});
